import React from "react";
import PropTypes from "prop-types";
import { Divider } from "antd";

const SelectorContainer = ({ heading, children }) => (
  <div>
    {/*<h4 style={{ marginTop: "8px", marginBottom: 0 }}>{heading}</h4>*/}
    <Divider orientation={"left"}>{heading}</Divider>
    <div>{children}</div>
  </div>
);

SelectorContainer.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired
};

export default SelectorContainer;



// WEBPACK FOOTER //
// ./src/views/components/selector_container/SelectorContainer.jsx